import { jsx } from "react/jsx-runtime";
import DeleteIcon from "@mui/icons-material/Delete";
import { validateTidalLicense } from "../../base/index.js";
function Delete(props) {
  return /* @__PURE__ */ jsx(
    DeleteIcon,
    {
      "data-testid": "Delete",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Delete",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
Delete.tidalIconMeta = {
  categories: "common,navigation",
  name: "Delete"
};
validateTidalLicense();
export {
  Delete
};
//# sourceMappingURL=Delete.js.map
